import RemoteController from '@/views/RemoteController/index.vue';
import { component } from 'vue/types/umd';

export default [
  {
    path: '/remoteController',
    name: '遥控器',
    component: RemoteController
  },
];
